import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {
  StyledFilter,
  StyledButtonPlus,
  StyledButtonUp,
  StyledButtonDown,
  StyledFilterText,
  StyledWrapperFlex
} from './style';

import Loading from '../../../core/Loading';
import Icon from '../../../core/Icon';
import { Arrow, Plus } from '../../../../../assets/images/index';

import { navigateToFile } from '../../../../utils/navigate';
import {
  findNewFolder,
  deleteNewFolder,
  getDocumentsAndFolders,
  deleteDocument,
  checkUserInGroup
} from '../../../../utils/apiDepartment';
import Documents from '../../../views/Documents';
import { API } from '../../../../constants/api';

const formatFoldersData = folders =>
  folders.map(item => ({
    ...item,
    title: item.folderName ? item.folderName : item.title,
    clientPath: null,
    fileExtension: 'FOLDER'
  }));

const formatFilesData = docs => {
  const re = /(?:\.([^.]+))?$/;
  return docs.map(item => ({
    ...item,
    fileExtension: re.exec(item.fileName)[1]
  }));
};

const formatLinksData = links =>
  links.map(item => ({
    ...item,
    fileExtension: 'LINK'
  }));

const ORDER = {
  ASC: 'asc',
  DESC: 'desc'
};

export default class InternalDocs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      departmentDocs: [],
      breadcrumbData: [{ txt: props.bcreadcrumbTitle, id: props.rootFolderId }],
      currentFolder: props.rootFolderId,
      currentFolderDocs: [],
      order: ORDER.ASC,
      loading: true,
      canCreateSubFolder: false,
      newSubfolderCreated: false,
      newSubfolderInfo: []
    };
  }

  componentDidMount() {
    const {
      history: {
        location: { state }
      }
    } = this.props;
    if (state) {
      this.setState({
        ...state
      });
    }
    this.checkFolderAndUpdateDocs();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.currentFolder !== this.state.currentFolder) {
      this.checkFolderAndUpdateDocs();
    }
  }

  // eslint-disable-next-line react/sort-comp
  checkFolderAndUpdateDocs() {
    const { currentFolder } = this.state;
    this.setState(() => ({ loading: false, currentFolderDocs: [] }));
    if (this.state.newSubfolderCreated) {
      this.onFileClick(this.state.newSubfolderInfo);
      this.setState({
        newSubfolderCreated: false,
        newSubfolderInfo: null
      });
    } else {
      findNewFolder(currentFolder)
        .then(response => {
          const createSubFolderGroupId = response
            ? response.createSubFolderGroupId
            : null;
          getDocumentsAndFolders(currentFolder).then(resp => {
            const { childNewFolders, files, links } = resp;
            const foldersUpdated = formatFoldersData(childNewFolders);
            const filesUpdated = formatFilesData(files);
            const linksUpdated = formatLinksData(links);
            this.setState({
              currentFolderDocs: [
                ...foldersUpdated,
                ...filesUpdated,
                ...linksUpdated
              ]
            });
          });
          if (createSubFolderGroupId) {
            const groupIdList = JSON.stringify(
              createSubFolderGroupId
            )?.substring(1, JSON.stringify(createSubFolderGroupId).length - 1);

            checkUserInGroup(groupIdList).then(data => {
              this.setState({
                canCreateSubFolder: data
              });
            });
          } else {
            this.setState({
              canCreateSubFolder: false
            });
          }
        })
        .catch(() => {});
    }
  }

  onBreadcrumbClick = selectedItem => {
    const { breadcrumbData } = this.state;
    const breadcrumbItemIndex = breadcrumbData.findIndex(
      item => item === selectedItem
    );
    const modifiedUrl = this.constructUrl(selectedItem);
    this.props.setUrl(modifiedUrl);
    this.setState({
      currentFolder: selectedItem.id,
      breadcrumbData: breadcrumbData.slice(0, breadcrumbItemIndex + 1)
    });
  };

  onFileClick = item => {
    if (item.folderName || item.baseContentType === 'FOLDER') {
      const { breadcrumbData } = this.state;
      this.setState({
        loading: true,
        currentFolder: item.id,
        breadcrumbData: [
          ...breadcrumbData,
          { txt: item.folderName ? item.folderName : item.title, id: item.id }
        ]
      });
      const modifiedUrl = this.constructUrl(item);
      this.props.setUrl(modifiedUrl);
    } else if (item.baseContentType === 'LINK') {
      if (item.newWindows) {
        navigateToFile(item.linkUrl);
      } else {
        navigateToFile(item.linkUrl, '_self');
      }
    } else {
      navigateToFile(`${API}/documents/documents${item.clientPath}`);
    }
  };

  navigateToNewFolder = folder => {
    const { history } = this.props;
    const { currentFolder } = this.state;
    // Guardamos el estado en el history
    history.replace(`${history.location.pathname}${history.location.search}`, {
      breadcrumbData: this.state.breadcrumbData,
      currentFolder
    });
    history.push({
      pathname: `/newFolder/${folder}`,
      state: {
        originPath: `${history.location.pathname}`,
        breadcrumbData: this.state.breadcrumbData,
        currentFolder
      }
    });
  };

  navigateToEditFolder = editFolderId => {
    const { history } = this.props;
    const { currentFolder } = this.state;
    // Guardamos el estado en el history
    history.replace(`${history.location.pathname}${history.location.search}`, {
      breadcrumbData: this.state.breadcrumbData,
      currentFolder
    });
    history.push({
      pathname: `/newFolder/${currentFolder}`,
      search: `folderId=${editFolderId}`,
      state: {
        originPath: `${history.location.pathname}`,
        breadcrumbData: this.state.breadcrumbData,
        currentFolder
      }
    });
  };

  navigateToNewFile = (folder, isStructure = false) => {
    const { history } = this.props;
    const { currentFolder } = this.state;
    const pathname = isStructure
      ? `/newFile/${folder}?isStructure=true`
      : `/newFile/${folder}`;
    history.push({
      pathname,
      state: {
        originPath: `${history.location.pathname}`,
        breadcrumbData: this.state.breadcrumbData,
        currentFolder
      }
    });
  };

  navigateToEditFile = editFileId => {
    const { history } = this.props;
    const { currentFolder } = this.state;
    // Guardamos el estado en el history
    history.replace(`${history.location.pathname}${history.location.search}`, {
      breadcrumbData: this.state.breadcrumbData,
      currentFolder
    });
    history.push({
      pathname: `/newFile/${currentFolder}`,
      search: `fileId=${editFileId}`,
      state: {
        originPath: `${history.location.pathname}`,
        breadcrumbData: this.state.breadcrumbData,
        currentFolder
      }
    });
  };

  onDeleteFolderClick = deleteFolderId => {
    deleteNewFolder(deleteFolderId).then(() => {
      this.checkFolderAndUpdateDocs();
    });
  };

  onDeleteFileClick = deleteFileId => {
    deleteDocument(deleteFileId).then(resp => {
      if (resp) {
        this.checkFolderAndUpdateDocs();
      }
    });
  };

  constructUrl = ({ id }) => {
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('folderId', id);
    return currentUrl.toString();
  };

  formatName = name => name.toLowerCase().replace(/ /g, '-');

  render() {
    const { rootFolderId } = this.props;
    const {
      currentFolder,
      currentFolderDocs,
      breadcrumbData,
      departmentDocs,
      loading,
      order,
      canCreateSubFolder
    } = this.state;

    const files = _.orderBy(
      rootFolderId === currentFolder
        ? [...departmentDocs, ...currentFolderDocs]
        : [...currentFolderDocs],
      [
        'baseContentType',
        file => (file.title || file.folderName || file.fileName).toLowerCase()
      ],
      ['desc', order]
    );

    if (loading) {
      return (
        <StyledWrapperFlex>
          <Loading size="xl" />
        </StyledWrapperFlex>
      );
    }

    return (
      <StyledWrapperFlex>
        <StyledFilter>
          {canCreateSubFolder && (
            <>
              <StyledFilterText>Crear Archivo</StyledFilterText>
              <StyledButtonPlus
                title="Crear Archivo"
                onClick={() => this.navigateToNewFile(currentFolder)}
                active
              >
                <Icon color="light" size="xs" svg={Plus} />
              </StyledButtonPlus>
              <StyledFilterText>Crear Carpeta</StyledFilterText>
              <StyledButtonPlus
                title="Crear Carpeta"
                onClick={() => this.navigateToNewFolder(currentFolder)}
                active
              >
                <Icon color="light" size="xs" svg={Plus} />
              </StyledButtonPlus>
              <StyledFilterText>Crear Estructura</StyledFilterText>
              <StyledButtonPlus
                title="Crear Estructura"
                onClick={() => this.navigateToNewFile(currentFolder, true)}
                active
              >
                <Icon color="light" size="xs" svg={Plus} />
              </StyledButtonPlus>
            </>
          )}
          <StyledButtonDown
            title="de la Z a la A"
            onClick={() => this.setState(() => ({ order: ORDER.DESC }))}
            active={order === ORDER.DESC}
          >
            <Icon svg={Arrow} width="14px" height="16px" />
          </StyledButtonDown>
          <StyledButtonUp
            title="de la A a la Z"
            onClick={() => this.setState(() => ({ order: ORDER.ASC }))}
            active={order === ORDER.ASC}
          >
            <Icon svg={Arrow} width="14px" height="16px" />
          </StyledButtonUp>
        </StyledFilter>

        <Documents
          files={files}
          breadcrumb={breadcrumbData}
          onBreadcrumbClick={this.onBreadcrumbClick}
          onFileClick={this.onFileClick}
          onEditFolderClick={this.navigateToEditFolder}
          onEditFileClick={this.navigateToEditFile}
          onDeleteFolderClick={this.onDeleteFolderClick}
          onDeleteFileClick={this.onDeleteFileClick}
        />
      </StyledWrapperFlex>
    );
  }
}

formatFoldersData.prototype = {
  rootFolderId: PropTypes.number,
  associationId: PropTypes.string,
  bcreadcrumbTitle: PropTypes.string
};
